import { format, isValid, parse } from 'date-fns';

export const formatDate = (date) => {
  return format(new Date(date), 'yyyy-MM-dd');
};

export const formatDateTime = (date) => {
  return format(new Date(date), 'yyyy-MM-dd HH:mm:ss');
};

export const formatDateTime2 = (date) => {
  return format(new Date(date), 'yyyy/MM/dd HH:mm');
};

export const dayMap = {
  MONDAY: { label: '星期一' },
  TUESDAY: { label: '星期二' },
  WEDNESDAY: { label: '星期三' },
  THURSDAY: { label: '星期四' },
  FRIDAY: { label: '星期五' },
  SATURDAY: { label: '星期六' },
  SUNDAY: { label: '星期日' },
};

export const getDayLabel = (dayOfWeek: string): string => {
  return dayMap[dayOfWeek]?.label || dayOfWeek;
};

/** 將使用者輸入（如 "0930"）格式化為 "HH:mm" 並驗證是否為合法時間。 */
export const formatAndValidateTime = (
  raw: string,
): { formatted: string; valid: boolean } => {
  const digits = raw.replace(/\D/g, '');
  if (digits.length !== 4) return { formatted: raw, valid: false };
  const parsed = parse(digits, 'HHmm', new Date());
  if (!isValid(parsed)) return { formatted: raw, valid: false };
  return { formatted: format(parsed, 'HH:mm'), valid: true };
};

/** 將 "HH:mm:ss" 時間字串正規化為顯示用的 "HH:mm"；不合法格式則原樣回傳。 */
export const formatTimeLabel = (raw: string): string => {
  const parsed = parse(raw, 'HH:mm:ss', new Date());
  return isValid(parsed) ? format(parsed, 'HH:mm') : raw;
};
